<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid login-orders-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Transaction Report</h4>
            <hr />
            <div class="mt-2">
              <div>
                <strong>Name: </strong>
                <span> {{ this.name }}</span>
              </div>
              <div>
                <strong>Total Points: </strong>
                <span v-if="this.transactionRecords.totalPoints == null"
                  >0</span
                >
                <span v-else>
                  {{
                    this.transactionRecords.totalPoints.toLocaleString()
                  }}</span
                >
              </div>

              <div>
                <strong>Total Records: </strong>
                <span v-if="this.transactionRecords.totalRecords == null"
                  >0</span
                >
                <span v-else>
                  {{
                    this.transactionRecords.totalRecords.toLocaleString()
                  }}</span
                >
              </div>
            </div>

            <div class="d-inline-flex mt-2">
              <div>
                <router-link
                  :to="{
                    name: 'AdminUserManagerEditUser',
                    params: { userId: this.$route.params.Id },
                  }"
                >
                  <button class="btn btn-primary mr-2">Edit</button>
                </router-link>
              </div>
              <div>
                <router-link
                  :to="{
                    name: 'AdminUserManagerPoints',
                    params: { userId: this.$route.params.Id },
                  }"
                >
                  <button class="btn btn-primary mr-2">Points</button>
                </router-link>
              </div>
              <div>
                <router-link
                  :to="{
                    name: 'AdminUserManager',
                  }"
                >
                  <button class="btn btn-primary mr-2">User Manager</button>
                </router-link>
              </div>
            </div>

            <div class="d-flex justify-content-between mt-3">
              <p>
                Click on any column header to sort on that column. Click again
                to reverse order.
              </p>
              <div class="d-inline-flex ms-2">
                <div>
                  <label class="mt-1">Show </label>
                </div>
                <div class="ms-2">
                  <b-select
                    class="form-select form-select-sm ml-1"
                    v-model.number="perPage"
                    @change="getTransactionDetails"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </b-select>
                </div>
                <div class="ms-2 ml-2"><label class="mt-1">entries</label></div>
              </div>
            </div>

            <div class="table-responsive mt-2">
              <table class="table table-hover table-bordered border-light">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      @click="sortOn('client_name')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Client Name
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortOn('[DATE]')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Date
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortOn('TYPE')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Type
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th scope="col">
                      <span style="white-space: nowrap;">By Whom </span>
                    </th>
                    <th
                      scope="col"
                      class="text-right"
                      @click="sortOn('dollars')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Dollars
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th
                      scope="col"
                      class="text-right"
                      @click="sortOn('order_number')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Points
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortOn('product')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Product
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortOn('')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Order Number
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortOn('program')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Program
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortOn('comments')"
                      style="cursor: pointer;"
                    >
                      <span style="white-space: nowrap;"
                        >Comments
                        <font-awesome-icon icon="sort" />
                      </span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-if="this.transactionRecords.Result === null">
                    <div class="">No data available in table</div>
                  </tr>
                  <tr v-if="loading === true">
                    <div>
                      <div class="centered">
                        <a-spin />
                      </div>
                    </div>
                  </tr>
                  <tr
                    v-for="(transaction, index) in this.transactionRecords
                      .Result"
                    :key="index"
                  >
                    <td class="white-space">{{ transaction.client_name }}</td>
                    <td class="white-space">
                      {{
                        moment(transaction.date).format("MM/DD/YYYY hh:mm A")
                      }}
                    </td>
                    <td>{{ transaction.type }}</td>
                    <td>{{ transaction.by_whom_user_name }}</td>
                    <td class="text-right">
                      {{
                        transaction.type === "order" ||
                        transaction.type === "order tax"
                          ? "-"
                          : ""
                      }}
                      {{
                        Number(transaction.dollars).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                      }}
                    </td>
                    <td class="text-right">
                      <span
                        v-if="
                          transaction.type === 'order' ||
                            transaction.type === 'Points Subtracted' ||
                            transaction.type === 'order tax'
                        "
                        class="badge badge-danger pl-1 pr-1"
                      >
                        {{
                          transaction.type === "order" ||
                          transaction.type === "order tax"
                            ? "-"
                            : ""
                        }}
                        {{
                          Number(transaction.points).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        }}</span
                      >
                      <span v-else class="badge badge-success pl-1 pr-1">{{
                        Number(transaction.points).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                      }}</span>
                    </td>
                    <td>{{ transaction.product }}</td>
                    <td>{{ transaction.order_number }}</td>
                    <td>{{ transaction.program }}</td>
                    <td>{{ transaction.comments }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-between mt-2">
              <div>
                <span v-if="transactionRecords.Result === null"
                  >Showing 0 to 0 of 0 entries</span
                >
                <span v-else
                  >Showing
                  {{ (currentPage - 1) * transactionRecords.pageSize + 1 }}
                  to
                  {{
                    (currentPage - 1) * transactionRecords.pageSize +
                      transactionRecords.selectedRecordCount
                  }}
                  of
                  {{ transactionRecords.totalRecords }} entries</span
                >
              </div>
              <div v-if="this.transactionRecords.Result">
                <pagination
                  :data="this.transactionRecords.Result"
                  :totalPages="
                    Math.ceil(this.transactionRecords.totalRecords / perPage)
                  "
                  :total="this.transactionRecords.totalRecords"
                  :perPage="perPage"
                  :currentPage="currentPage"
                  @pagechanged="onPageChange"
                />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import Pagination from "@/components/Pagination.vue";

import moment from "moment";

export default {
  name: "TransactionRecordDetail",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    pagination: Pagination,
  },

  data() {
    return {
      loading: false,
      perPage: 10,
      currentPage: 1,
      sort_field: "[DATE]",
      sort_order: "ASC",
    };
  },
  computed: {
    transactionRecords() {
      return this.$store.getters["transactionReport/getTransactionRecords"];
    },
    name() {
      return this.$store.state.transactionReport.name;
    },
  },
  mounted() {
    this.scrollToTop();
    this.getTransactionDetails();
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsTransactionReport",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },
    sortOn(field) {
      this.sort_order =
        this.sort_field === field && this.sort_order === "ASC" ? "DESC" : "ASC";
      this.sort_field = field;
      this.getTransactionDetails();
    },
    onPageChange(page) {
      console.log("page changed", page);
      this.currentPage = page;
      this.getTransactionDetails();
    },
    getTransactionDetails() {
      this.loading = true;
      this.$store
        .dispatch("transactionReport/fetchTransactionReport", {
          pg_num: this.currentPage,
          pg_size: this.perPage,
          sort_field: this.sort_field,
          sort_order: this.sort_order,
          userId: this.$route.params.Id,
        })
        .then(() => {
          this.loading = false;
        });
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("MM-DD-YYYY");
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.login-orders-report {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}

.table-sm {
  font-size: 0.8rem;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.white-space {
  white-space: nowrap !important;
}

html,
body {
  height: 100%;
}
</style>
